import Button from 'components/common/Button';
import Icon from 'components/common/Icon';
import CardSlider from 'components/view/CardSlider';
import useBottomSheet from 'hooks/common/useBottomSheet';
import { useLottiePlayer } from 'hooks/common/useLottiePlayer';
import { useEffect, useState } from 'react';
import { Product } from 'types/model';

const TimeBuffDiscount = () => {
  const { open, close, sheets } = useBottomSheet();
  const sheet = sheets.TimeBuffDiscount;
  const [selectedIdx, setSelectedIdx] = useState<number>(0);
  const [products, setProducts] = useState<Product[]>([]);

  useEffect(() => {
    setProducts(TimeBuffManager.getDiscountProduct() ?? []);

    return () => {
      PurchaseManager.detach();
    };
  }, []);

  const handleClickPurchase = () => {
    const product = products[selectedIdx];
    PurchaseManager.attach((err: any, purchaseCoin: any, productId: string) => {
      if (!err && productId.includes('timebuff')) {
        close(sheet.id);
        open('TimeBuffPurchaseComplete');
      }
    });
    PurchaseManager.buyCoin(product.productId);
    TimeBuffLogger.logPurchase('clickQuantity', product.productId);
  };

  return (
    <div className="flex h-full w-full flex-col">
      <div className="flex h-[56px] w-full">
        <Icon name="icon/ic_close.svg" onClick={() => close(sheet.id)} />
      </div>
      <div className="w-full text-center text-[96px] font-black text-[#FF4390]">{-50}%</div>
      <div className="text3 mt-2 whitespace-pre-wrap text-center text-white">{brsc.dicount_time_buff_popup_1.replace('<br>', '\n')}</div>
      <CardSlider
        className="px-24 py-12"
        items={products}
        buildItems={(item, index) => <CardItem key={`${item.productId}_${index}`} product={item} selected={index === selectedIdx ? true : false} />}
        onSelect={setSelectedIdx}
        currentIndex={selectedIdx}
      />
      <Button style={{ text: brsc.purchase }} className="mx-4" onClick={handleClickPurchase} />
      <div className="flex-column mt-2 flex items-start justify-center gap-2 p-4 text-center text-white">
        <div className="pl-2 typography-headline-lg">Check point☝️</div>
        <ul className="m-0 px-4 py-0 text-start typography-body-sm">
          <li>{brsc.dicount_time_buff_popup_2}</li>
          <li>{brsc.dicount_time_buff_popup_3}</li>
        </ul>
      </div>
    </div>
  );
};

interface CardItemProps {
  product: Product;
  selected: boolean;
}

const CardItem: React.FC<CardItemProps> = ({ product, selected }) => {
  const emojiMap: { [key: number]: string } = { 1: '', 3: '✨', 5: '🔥' };
  const { count, price, originalPrice, price_currency_code } = product;
  const emoji = emojiMap[count];
  const { playerRef } = useLottiePlayer({ autoplay: selected, loop: true, speed: 1 });

  const background = selected ? 'linear-gradient(154deg, rgba(255, 173, 207, 0.50) 0%, rgba(255, 67, 144, 0.50) 100%)' : 'rgba(255, 255, 255, 0.30)';
  const border = selected ? '1px solid #FF4390' : undefined;
  return (
    <div className="flex flex-col gap-4 rounded-lg px-4 py-10 text-white" style={{ background, border, minWidth: '200px', maxWidth: '200px' }}>
      <div className="flex justify-center whitespace-nowrap typography-title-md">{brsc.time_buff + ' ' + brsc.count_item.replace('$param', count)}</div>
      {selected && (
        <div className="flex flex-col items-center">
          <lottie-player ref={playerRef} src="/imgweb/lottie/time_buff_infinity.json" style={{ width: '120px', height: '60px' }} />
          <div className="text4 text-center">
            {emoji}
            {count * (TimeBuffManager.BUFF_DURATION / (1000 * 60))}min{emoji}
          </div>
        </div>
      )}
      <div className="align-center flex flex-row justify-center gap-2">
        <div className="relative inline-block w-fit">
          <div className="diagonal-text h-fit w-fit typography-body-sm">{PageShop.numberToCurrencyString(originalPrice, price_currency_code)}</div>
        </div>
        <div className="typography-headline-lg">{PageShop.numberToCurrencyString(price, price_currency_code)}</div>
      </div>
    </div>
  );
};

export default TimeBuffDiscount;
